import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=026ba39a&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=ts"
export * from "./BaseModal.vue?vue&type=script&lang=ts"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=026ba39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026ba39a",
  null
  
)

export default component.exports